import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import PageTitle from './PageTitle-redux';

export default compose(
    withRouter
)(PageTitle);
